import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

export const StyledModal = styled(Modal)({
  width: 560,
});
